import "./styles.css";
import { useLang } from "../../context/langProvider";
import { entreprises } from "../../datas/mockedData";
import CardPrestataire from "../CardPrestataire";

function getRandomFilteredCompanies(entreprises, city, n) {
  if (!city) return [];
  const filtered = entreprises//.filter(ent => ent.city === city);
  for (let i = filtered.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [filtered[i], filtered[j]] = [filtered[j], filtered[i]];
  }
  return filtered.slice(0, n);
}



const BestPrestataireSection = () => {
  const { t } = useLang();
  const listPrestataires = getRandomFilteredCompanies(entreprises, "Paris", 3);
console.log(listPrestataires)
  return (
    <section className="best-prestataires-section background-secondary">
      <h2>{t("best-providers-near-you")}</h2>
      <div className="container-cards-presta">
        {listPrestataires.length > 0 ? (
          listPrestataires.map(prestataire => (
            <CardPrestataire key={prestataire.id} entreprise={prestataire} />
          ))
        ) : (
          <p>{t("no-providers-found")}</p>
        )}
      </div>
    </section>
  );
};

export default BestPrestataireSection;
